import { baseEnvironment } from "./environment.base";

export const environment = {
    production: true,
    apiBaseUrl: 'https://sandbox.api.creditburj.com/api/v1/',
    businessKey:'3MKEM842Op9gZ3XFAJEecbjGZiH9Yr7B4',
    ...baseEnvironment,
};